import React from 'react';
import { motion } from 'framer-motion';

const FloatingWhatsApp = () => {
  const message = encodeURIComponent('Hola! Me interesa conocer más sobre los servicios náuticos de GRU Corporación.');
  // Venezuela country code is +58
  const phoneNumber = '584227000477'; // WhatsApp: +58 422 700 0477
  
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
  
  const handleWhatsAppClick = () => {
    console.log('Trying WhatsApp URL:', whatsappUrl);
    window.open(whatsappUrl, '_blank');
  };

  return (
    <motion.div
      className="fixed bottom-6 right-6 z-50 whatsapp-button"
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ 
        type: "spring", 
        stiffness: 260, 
        damping: 20, 
        delay: 0.5 
      }}
      style={{
        position: 'fixed',
        bottom: '1.5rem',
        right: '1.5rem',
        zIndex: 9999
      }}
    >
      <motion.div
        onClick={handleWhatsAppClick}
        className="w-16 h-16 rounded-full flex items-center justify-center shadow-xl cursor-pointer transition-all duration-300"
        style={{
          backgroundColor: '#25D366'
        }}
        whileHover={{ 
          scale: 1.1,
          boxShadow: '0 20px 25px -5px rgba(37, 211, 102, 0.4), 0 10px 10px -5px rgba(37, 211, 102, 0.3)'
        }}
        whileTap={{ scale: 0.95 }}
        title="Contactar por WhatsApp"
        aria-label="Contactar por WhatsApp"
      >
        <motion.svg
          viewBox="0 0 24 24"
          className="w-8 h-8 fill-white pointer-events-none"
          whileHover={{ scale: 1.1 }}
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.484 3.488"/>
        </motion.svg>
      </motion.div>
      
      {/* Pulse animation ring - positioned behind button */}
      <motion.div
        className="absolute inset-0 rounded-full border-2 pointer-events-none"
        animate={{
          scale: [1, 1.5, 1],
          opacity: [0.6, 0, 0.6],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        style={{
          backgroundColor: 'transparent',
          borderColor: '#22c55e',
          zIndex: -1
        }}
      />
      
      {/* Mobile responsive adjustments */}
      <style>{`
        @media (max-width: 640px) {
          .whatsapp-button {
            bottom: 1.5rem !important;
            right: 1.5rem !important;
          }
        }
        
        @media (max-width: 480px) {
          .whatsapp-button {
            bottom: 1rem !important;
            right: 1rem !important;
          }
        }
      `}</style>
    </motion.div>
  );
};

export default FloatingWhatsApp;